/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_PlInputs */

const en_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const es_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const de_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const zh_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const ar_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const fr_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const vi_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const sw_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const th_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const bs_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const ja_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const ko_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const pt_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const it_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const sv_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const nl_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const da_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const nb_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const fi_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const pl_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const ru_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const tr_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const hi_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const id_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const ms_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const cs_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const el_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const he_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const af_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

const hu_nav_language_pl = /** @type {(inputs: Nav_Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

/**
* | output |
* | --- |
* | "Polski" |
*
* @param {Nav_Language_PlInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_pl = /** @type {((inputs?: Nav_Language_PlInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_PlInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_pl(inputs)
	if (locale === "de") return de_nav_language_pl(inputs)
	if (locale === "zh") return zh_nav_language_pl(inputs)
	if (locale === "ar") return ar_nav_language_pl(inputs)
	if (locale === "fr") return fr_nav_language_pl(inputs)
	if (locale === "vi") return vi_nav_language_pl(inputs)
	if (locale === "sw") return sw_nav_language_pl(inputs)
	if (locale === "th") return th_nav_language_pl(inputs)
	if (locale === "bs") return bs_nav_language_pl(inputs)
	if (locale === "ja") return ja_nav_language_pl(inputs)
	if (locale === "ko") return ko_nav_language_pl(inputs)
	if (locale === "pt") return pt_nav_language_pl(inputs)
	if (locale === "it") return it_nav_language_pl(inputs)
	if (locale === "sv") return sv_nav_language_pl(inputs)
	if (locale === "nl") return nl_nav_language_pl(inputs)
	if (locale === "da") return da_nav_language_pl(inputs)
	if (locale === "nb") return nb_nav_language_pl(inputs)
	if (locale === "fi") return fi_nav_language_pl(inputs)
	if (locale === "pl") return pl_nav_language_pl(inputs)
	if (locale === "ru") return ru_nav_language_pl(inputs)
	if (locale === "tr") return tr_nav_language_pl(inputs)
	if (locale === "hi") return hi_nav_language_pl(inputs)
	if (locale === "id") return id_nav_language_pl(inputs)
	if (locale === "ms") return ms_nav_language_pl(inputs)
	if (locale === "cs") return cs_nav_language_pl(inputs)
	if (locale === "el") return el_nav_language_pl(inputs)
	if (locale === "he") return he_nav_language_pl(inputs)
	if (locale === "af") return af_nav_language_pl(inputs)
	if (locale === "hu") return hu_nav_language_pl(inputs)
	return en_nav_language_pl(inputs)
});